(function () {
  'use strict';

  var root = document.getElementById('tour-calendar-app');
  if (!root) return;

  var config = {
    shopDomain: root.dataset.shopDomain,
    storefrontToken: root.dataset.storefrontToken,
    apiVersion: root.dataset.apiVersion || '2024-10',
    productHandle: root.dataset.productHandle,
    checkoutMode: root.dataset.checkoutMode || 'checkout' // 'checkout' o 'cart'
  };

  var WARNING_THRESHOLD = 6; // <= 6 spots => amarillo
  var URGENT_THRESHOLD = 3;  // <= 3 spots => naranja

  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var MONTH_ABBR_TO_INDEX = {
    jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
    jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
  };
  var DAY_NAMES = ['Su','Mo','Tu','We','Th','Fr','Sa'];

  // "Jan 18th 2026 to Feb 2nd 2026" -> { start: Date, end: Date }
  var TITLE_RE = /^([A-Za-z]{3})[A-Za-z]*\.?\s+(\d{1,2})(?:st|nd|rd|th)\s+(\d{4})\s+to\s+([A-Za-z]{3})[A-Za-z]*\.?\s+(\d{1,2})(?:st|nd|rd|th)\s+(\d{4})$/i;

  function parseVariantTitle(title) {
    var m = TITLE_RE.exec((title || '').trim());
    if (!m) return null;
    var startMonth = MONTH_ABBR_TO_INDEX[m[1].toLowerCase().slice(0, 3)];
    var endMonth = MONTH_ABBR_TO_INDEX[m[4].toLowerCase().slice(0, 3)];
    if (startMonth === undefined || endMonth === undefined) return null;
    var start = new Date(parseInt(m[3], 10), startMonth, parseInt(m[2], 10));
    var end = new Date(parseInt(m[6], 10), endMonth, parseInt(m[5], 10));
    return { start: start, end: end };
  }

  function pad(n) { return String(n).padStart(2, '0'); }
  function dateKey(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function dateFromKey(k) { var p = k.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function sameMonth(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth(); }
  function dateToTs(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(); }
  function numericVariantId(gid) { return gid.split('/').pop(); }
  function formatMoney(amount, currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(amount);
    } catch (e) {
      return currencyCode + ' ' + amount.toFixed(2);
    }
  }

  function classify(qty) {
    if (qty <= 0) return 'sold-out';
    if (qty <= URGENT_THRESHOLD) return 'urgent';
    if (qty <= WARNING_THRESHOLD) return 'warning';
    return 'available';
  }

  var els = {
    sub: document.getElementById('uc-sub'),
    grid: document.getElementById('uc-grid'),
    btnPrev: document.getElementById('uc-btn-prev'),
    btnNext: document.getElementById('uc-btn-next'),
    navYear: document.getElementById('uc-nav-year'),
    selectedInfo: document.getElementById('uc-selected-info'),
    btnBook: document.getElementById('uc-btn-book'),
    error: document.getElementById('uc-error'),
    qtyWrap: document.getElementById('uc-quantity-wrap'),
    qtyMax: document.getElementById('uc-quantity-max'),
    qty: document.getElementById('uc-quantity'),
    qtyMinus: document.getElementById('uc-qty-minus'),
    qtyPlus: document.getElementById('uc-qty-plus'),
    step1: document.getElementById('uc-step1'),
    btnReview: document.getElementById('uc-btn-review'),
    reviewWrap: document.getElementById('uc-review-wrap'),
    reviewDeparture: document.getElementById('uc-review-departure'),
    reviewReturn: document.getElementById('uc-review-return'),
    reviewTravelers: document.getElementById('uc-review-travelers'),
    reviewPriceBox: document.getElementById('uc-review-price-box'),
    reviewPriceLabel: document.getElementById('uc-review-price-label'),
    reviewPriceAmount: document.getElementById('uc-review-price-amount'),
    reviewNote: document.getElementById('uc-review-note'),
    btnChange: document.getElementById('uc-btn-change')
  };

  var availability = {}; // dateKey -> { status, qty, variantId, endDate: dateKey }
  var current = new Date();
  var minMonth = new Date();
  var maxMonth = new Date();
  var selectedDate = null;
  var endDate = null;
  var selectedVariantId = null;
  var selectedMaxQty = 1;
  var currentSelection = null;
  var animating = false;

  function showError(msg) {
    els.error.hidden = false;
    els.error.textContent = msg;
  }

  function fetchVariantsPage(cursor) {
    var query =
      'query getProduct($handle: String!, $cursor: String) @inContext(language: EN) {' +
      '  product(handle: $handle) {' +
      '    variants(first: 100, after: $cursor) {' +
      '      edges { cursor node { id title quantityAvailable availableForSale price { amount currencyCode } } }' +
      '      pageInfo { hasNextPage }' +
      '    }' +
      '  }' +
      '}';

    var endpoint = 'https://' + config.shopDomain + '/api/' + config.apiVersion + '/graphql.json';

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.storefrontToken
      },
      body: JSON.stringify({ query: query, variables: { handle: config.productHandle, cursor: cursor || null } })
    }).then(function (r) { return r.json(); });
  }

  function fetchAllVariants() {
    var allEdges = [];

    function loadPage(cursor) {
      return fetchVariantsPage(cursor).then(function (json) {
        if (json.errors || !json.data || !json.data.product) {
          throw new Error('Could not load availability from the Shopify Storefront API.');
        }
        var variants = json.data.product.variants;
        allEdges = allEdges.concat(variants.edges);
        if (variants.pageInfo.hasNextPage) {
          var lastCursor = variants.edges[variants.edges.length - 1].cursor;
          return loadPage(lastCursor);
        }
        return allEdges;
      });
    }

    return loadPage(null);
  }

  function fetchAvailability() {
    return fetchAllVariants()
      .then(function (edges) {
        var map = {};
        var min = null, max = null;
        var skipped = [];

        edges.forEach(function (edge) {
          var v = edge.node;
          var parsed = parseVariantTitle(v.title);
          if (!parsed) { skipped.push(v.title); return; }

          var startKey = dateKey(parsed.start);
          var endKey = dateKey(parsed.end);
          var qty = typeof v.quantityAvailable === 'number' ? v.quantityAvailable : 0;

          map[startKey] = {
            status: classify(qty),
            qty: qty,
            variantId: numericVariantId(v.id),
            endDate: endKey,
            startLabel: parsed.start,
            endLabel: parsed.end,
            unitPrice: v.price ? parseFloat(v.price.amount) : null,
            currencyCode: v.price ? v.price.currencyCode : null
          };

          if (min === null || parsed.start < min) min = parsed.start;
          if (max === null || parsed.start > max) max = parsed.start;
        });

        if (skipped.length > 0) {
          console.warn('[tour-calendar] ' + skipped.length + ' variant title(s) did not match the expected "Mon Dst YYYY to Mon Dst YYYY" format and were skipped:', skipped);
        }

        availability = map;

        if (min && max) {
          minMonth = new Date(min.getFullYear(), min.getMonth());
          maxMonth = new Date(max.getFullYear(), max.getMonth());
          var today = new Date();
          current = min < today ? new Date(today.getFullYear(), today.getMonth()) : new Date(min.getFullYear(), min.getMonth());
          if (current < minMonth) current = minMonth;
          if (current > maxMonth) current = maxMonth;
          populateYearSelect();
        }
      });
  }

  function populateYearSelect() {
    els.navYear.innerHTML = '';
    for (var y = minMonth.getFullYear(); y <= maxMonth.getFullYear(); y++) {
      var opt = document.createElement('option');
      opt.value = y;
      opt.textContent = y;
      els.navYear.appendChild(opt);
    }
  }

  function updateNavButtons() {
    els.btnPrev.disabled = sameMonth(current, minMonth);
    els.btnNext.disabled = sameMonth(current, maxMonth);
    els.navYear.value = String(current.getFullYear());
  }

  function jumpToYear(year) {
    var month = (year === minMonth.getFullYear()) ? minMonth.getMonth() : 0;
    if (year === maxMonth.getFullYear() && month > maxMonth.getMonth()) month = maxMonth.getMonth();
    current = new Date(year, month);
    renderCalendar();
  }

  function buildGrid() {
    var frag = document.createDocumentFragment();
    var startTs = selectedDate ? dateToTs(dateFromKey(selectedDate)) : null;
    var endTs = endDate ? dateToTs(dateFromKey(endDate)) : null;

    for (var m = 0; m < 2; m++) {
      var d = new Date(current.getFullYear(), current.getMonth() + m, 1);
      var col = document.createElement('div');

      var title = document.createElement('div');
      title.className = 'uc-month-title';
      title.textContent = MONTHS[d.getMonth()] + ' ' + d.getFullYear();
      col.appendChild(title);

      var hdr = document.createElement('div');
      hdr.className = 'uc-days-header';
      DAY_NAMES.forEach(function (dy) {
        var s = document.createElement('span');
        s.textContent = dy;
        hdr.appendChild(s);
      });
      col.appendChild(hdr);

      var daysDiv = document.createElement('div');
      daysDiv.className = 'uc-days';
      var firstDay = d.getDay();
      var daysInMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
      var ri = 0;

      for (var i = 0; i < firstDay; i++) daysDiv.appendChild(document.createElement('div'));

      (function (year, month) {
        for (var day = 1; day <= daysInMonth; day++) {
          var k = dateKey(new Date(year, month, day));
          var info = availability[k];
          var status = info ? info.status : null;
          var cell = document.createElement('div');
          var ts = dateToTs(new Date(year, month, day));

          if (startTs && endTs && ts === startTs) {
            cell.className = 'uc-day uc-range-start';
            cell.style.animationDelay = '0ms';
          } else if (startTs && endTs && ts === endTs) {
            cell.className = 'uc-day uc-range-end';
            cell.style.animationDelay = '260ms';
          } else if (startTs && endTs && ts > startTs && ts < endTs) {
            ri++;
            cell.className = 'uc-day uc-in-range';
            cell.style.animationDelay = (ri * 18) + 'ms';
          } else {
            cell.className = 'uc-day uc-' + (status || 'inactive');
          }

          var num = document.createElement('span');
          num.textContent = day;
          cell.appendChild(num);

          var inSelectedRange = startTs && ts >= startTs && ts <= endTs;
          if ((status === 'warning' || status === 'urgent') && !inSelectedRange) {
            var badge = document.createElement('span');
            badge.className = 'uc-spots-badge';
            badge.textContent = info.qty + (info.qty === 1 ? ' spot' : ' spots');
            cell.appendChild(badge);
          }

          if (status && status !== 'sold-out') {
            cell.style.cursor = 'pointer';
            (function (key, variantInfo) {
              cell.addEventListener('click', function () { selectDate(key, variantInfo); });
            })(k, info);
          }

          daysDiv.appendChild(cell);
        }
      })(d.getFullYear(), d.getMonth());

      col.appendChild(daysDiv);
      frag.appendChild(col);
    }
    return frag;
  }

  function renderCalendar() {
    els.grid.innerHTML = '';
    els.grid.appendChild(buildGrid());
    updateNavButtons();
  }

  function animateGrid(outClass, inClass, callback) {
    if (animating) return;
    animating = true;
    els.grid.classList.add(outClass);
    setTimeout(function () {
      els.grid.classList.remove(outClass);
      els.grid.innerHTML = '';
      callback();
      els.grid.appendChild(buildGrid());
      els.grid.classList.add(inClass);
      updateNavButtons();
      setTimeout(function () {
        els.grid.classList.remove(inClass);
        animating = false;
      }, 340);
    }, 300);
  }

  function navigate(dir) {
    if (animating) return;
    if (dir === 1 && sameMonth(current, maxMonth)) return;
    if (dir === -1 && sameMonth(current, minMonth)) return;
    var next = new Date(current.getFullYear(), current.getMonth() + dir);
    var outClass = dir === 1 ? 'uc-slide-out-left' : 'uc-slide-out-right';
    var inClass = dir === 1 ? 'uc-slide-in-left' : 'uc-slide-in-right';
    animateGrid(outClass, inClass, function () { current = next; });
  }

  function selectDate(key, info) {
    selectedDate = key;
    endDate = info.endDate;
    selectedVariantId = info.variantId;
    currentSelection = info;

    var visibleSecond = new Date(current.getFullYear(), current.getMonth() + 1);
    var endD = dateFromKey(info.endDate);
    var endMonth = new Date(endD.getFullYear(), endD.getMonth());

    if (endMonth > visibleSecond) {
      var diff = (endMonth.getFullYear() - visibleSecond.getFullYear()) * 12 + (endMonth.getMonth() - visibleSecond.getMonth());
      animateGrid('uc-slide-out-left', 'uc-slide-in-left', function () {
        current = new Date(current.getFullYear(), current.getMonth() + diff);
      });
    } else {
      renderCalendar();
    }

    els.selectedInfo.classList.add('uc-updating');
    setTimeout(function () {
      var EM_DASH = String.fromCharCode(0x2014);
      var ARROW = String.fromCharCode(0x2192);
      var label = info.status === 'warning' ? ' ' + EM_DASH + ' ' + info.qty + ' spots left'
        : info.status === 'urgent' ? ' ' + EM_DASH + ' only ' + info.qty + ' spots left'
        : '';
      els.selectedInfo.textContent =
        'Departure: ' + MONTHS[info.startLabel.getMonth()] + ' ' + info.startLabel.getDate() + ', ' + info.startLabel.getFullYear() +
        ' ' + ARROW + ' Ends: ' + MONTHS[info.endLabel.getMonth()] + ' ' + info.endLabel.getDate() + ', ' + info.endLabel.getFullYear() + label;
      els.selectedInfo.classList.remove('uc-updating');
    }, 150);

    selectedMaxQty = info.qty;
    els.qty.max = String(selectedMaxQty);
    if (parseInt(els.qty.value, 10) > selectedMaxQty || !els.qty.value) {
      els.qty.value = '1';
    }
    els.qtyMax.textContent = selectedMaxQty + (selectedMaxQty === 1 ? ' spot available' : ' spots available');
    els.qtyWrap.hidden = false;
    els.qtyWrap.style.animation = 'none';
    els.qtyWrap.offsetHeight; /* restart fade-in on re-select */
    els.qtyWrap.style.animation = '';
    updateQtyButtons();

    els.btnReview.disabled = false;
  }

  function clampQty(value) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > selectedMaxQty) n = selectedMaxQty;
    return n;
  }

  function updateQtyButtons() {
    var n = clampQty(els.qty.value);
    els.qtyMinus.disabled = n <= 1;
    els.qtyPlus.disabled = n >= selectedMaxQty;
  }

  function showReview() {
    if (!currentSelection) return;
    var info = currentSelection;
    var quantity = clampQty(els.qty.value);

    els.reviewDeparture.textContent = MONTHS[info.startLabel.getMonth()] + ' ' + info.startLabel.getDate() + ', ' + info.startLabel.getFullYear();
    els.reviewReturn.textContent = MONTHS[info.endLabel.getMonth()] + ' ' + info.endLabel.getDate() + ', ' + info.endLabel.getFullYear();
    els.reviewTravelers.textContent = String(quantity);

    if (typeof info.unitPrice === 'number' && info.currencyCode) {
      var total = info.unitPrice * quantity;
      els.reviewPriceLabel.textContent = 'Reservation deposit - ' + quantity + (quantity === 1 ? ' traveler' : ' travelers');
      els.reviewPriceAmount.textContent = formatMoney(total, info.currencyCode);
      els.reviewNote.textContent = formatMoney(info.unitPrice, info.currencyCode) + ' per person to secure your spots on this departure. Excludes tax, calculated at checkout. Trip balance arranged separately.';
      els.reviewPriceBox.hidden = false;
    } else {
      els.reviewPriceBox.hidden = true;
    }

    els.step1.hidden = true;
    els.reviewWrap.hidden = false;
  }

  function showStep1() {
    els.reviewWrap.hidden = true;
    els.step1.hidden = false;
  }

  function bookNow() {
    if (!selectedVariantId) return;
    var quantity = clampQty(els.qty.value);
    els.btnBook.disabled = true;
    els.btnBook.classList.add('uc-loading');
    els.error.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: quantity }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Could not add to cart.');
        return r.json();
      })
      .then(function () {
        window.location.href = config.checkoutMode === 'cart' ? '/cart' : '/checkout';
      })
      .catch(function (err) {
        showError(err.message || 'Something went wrong booking your reservation. Please try again.');
        els.btnBook.disabled = false;
        els.btnBook.classList.remove('uc-loading');
      });
  }

  function init() {
    if (!config.shopDomain || !config.productHandle) {
      showError('Calendar configuration is missing.');
      return;
    }
    if (!config.storefrontToken || config.storefrontToken.indexOf('STOREFRONT_ACCESS_TOKEN') === 0) {
      showError('Storefront API access token is not configured (see INSTALL.md).');
      return;
    }

    fetchAvailability()
      .then(function () {
        renderCalendar();
      })
      .catch(function (err) {
        showError(err.message || 'Could not load availability.');
      });

    els.btnPrev.addEventListener('click', function () { navigate(-1); });
    els.btnNext.addEventListener('click', function () { navigate(1); });
    els.navYear.addEventListener('change', function () {
      jumpToYear(parseInt(els.navYear.value, 10));
    });
    els.btnReview.addEventListener('click', showReview);
    els.btnChange.addEventListener('click', showStep1);
    els.btnBook.addEventListener('click', bookNow);

    els.qtyMinus.addEventListener('click', function () {
      els.qty.value = String(clampQty(els.qty.value) - 1);
      updateQtyButtons();
    });
    els.qtyPlus.addEventListener('click', function () {
      els.qty.value = String(clampQty(els.qty.value) + 1);
      updateQtyButtons();
    });
    els.qty.addEventListener('change', function () {
      els.qty.value = String(clampQty(els.qty.value));
      updateQtyButtons();
    });
  }

  init();
})();